/* eslint-disable no-console */
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  private ctx: string[] = [];

  isProduction = environment.production;
  //eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  writeLog(logfn: Function, msg: any, ...optionalParams: any[]): void {
    if (this.isProduction) {
      return;
    }
    if (this.ctx.length === 0) {
      logfn.call(this, msg, ...optionalParams);
    } else {
      logfn.call(this, `[${this.ctx.join('.')}]`, msg, ...optionalParams);
    }
  }
  log(msg: any, ...optionalParams: any[]): void {
    this.writeLog(console.info, msg, ...optionalParams);
  }

  error(msg: any, ...optionalParams: any[]): void {
    this.writeLog(console.error, msg, ...optionalParams);
  }

  warn(msg: any, ...optionalParams: any[]): void {
    this.writeLog(console.warn, msg, ...optionalParams);
  }
  debug(msg: any, ...optionalParams: any[]): void {
    this.writeLog(console.debug, msg, ...optionalParams);
  }

  //eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  withContext(childCtx: string | Function): LoggerService {
    const logger = new LoggerService();
    if (typeof childCtx === 'function') {
      childCtx = childCtx.name.replace(/^_/, '');
    }
    logger.ctx = [...this.ctx, childCtx];
    return logger;
  }
}
